export default "__VITE_ASSET__DbxyrFO8__"